import { useEffect, useState } from "react"

import { Page, Text, Image, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

import { styles } from '../styles/styles'

export const innerStyles = StyleSheet.create({
    heading1: {
        fontFamily: 'Times-Bold',
        fontSize: 13
    },
    heading2: {
        fontFamily: 'Times-Roman',
        fontSize: 9
    },
    documentName: {
        fontFamily: 'Times-Bold',
        ...styles.h13,
        textAlign: 'center'
    },
    documentNumber: {
        // fontFamily: 'Times-Bold',
        // textAlign: 'center'
    }
});

export function Header({ pageNumber, totalPages, document, data }) {

    if (!document) return false

    const {
        documentName,
    } = document;

    // const RenderSection1 = () => {
    //     return (
    //         <View
    //             style={{
    //                 width: '100%'
    //             }}
    //         >
    //             <View
    //                 style={{
    //                     // borderTopWidth: 1,
    //                     // borderTopStyle: 'solid',
    //                     // borderTopColor: '#000',

    //                     // borderBottomWidth: 1,
    //                     // borderBottomStyle: 'solid',
    //                     // borderBottomColor: '#000',

    //                     // borderLeftWidth: 1,
    //                     // borderLeftStyle: 'solid',
    //                     // borderLeftColor: '#000',

    //                     // borderRightWidth: 1,
    //                     // borderRightStyle: 'solid',
    //                     // borderRightColor: '#000',

    //                 }}
    //             >
    //                 <Image
    //                     src="/assets/images/system_logo_full.png" 
    //                     style={{
    //                         width: '50',
    //                         height: '50'
    //                     }}
    //                 />
    //             </View>
    //         </View>
    //     )
    // }

    const RenderSection2 = () => {
        return (
            <View
                style={{
                    width: '100%'
                }}
            >
                <View
                    style={{
                        borderTopWidth: 1,
                        borderTopStyle: 'solid',
                        borderTopColor: '#000',

                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#000',

                        borderLeftWidth: 1,
                        borderLeftStyle: 'solid',
                        borderLeftColor: '#000',

                        borderRightWidth: 1,
                        borderRightStyle: 'solid',
                        borderRightColor: '#000',

                        marginBottom: 5

                    }}
                >
                    <Text
                        style={innerStyles.documentName}
                    >
                        {documentName.toUpperCase()}
                    </Text>
                </View>
                <Text
                    style={innerStyles.documentName}
                >
                    {data?.location_name}
                </Text>
            </View>
        )
    }

    const RenderSection3 = ({ data }) => {
        return (
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: "flex-end"
                }}
            >
                <View>
                    <Image
                        src={data?.qrCodeData}
                        style={{
                            width: '50',
                            height: '50'
                        }}
                    />
                </View>
            </View>
        )
    }

    return (
        <View style={{
            width: '100%',
            // backgroundColor: 'red'
        }}>
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    // borderBottomColor: '#000',
                    // borderBottomStyle: 'solid',
                    // borderBottomWidth: 0.5,
                }}
            >
                {/* <View
                    style={{
                        width: '20%',
                        flexWrap: 'wrap'
                    }}>
                    <RenderSection1 />
                </View> */}
                <View
                    style={{
                        width: '80%',
                        flexWrap: 'wrap'
                    }}>
                    <RenderSection2 />
                </View>
                <View
                    style={{
                        width: '20%',
                        // flex: 1
                    }}
                >
                    <RenderSection3
                        data={data}
                    />

                </View>
            </View>
            <View
                style={{
                    textAlign: 'right',
                    // display: 'flex',
                    // flexDirection: 'row',
                    // justifyContent: 'space-between',
                    // alignItems: 'center',
                }}
            >
                {/* <Text style={styles.h10}>
                    {pageNumber} / {totalPages} ({data?.uom_lbl})
                </Text> */}
                <Text style={[styles.h10, styles.textAlignRight]}>
                    {data?.number_alternative}
                </Text>
            </View>
        </View>
    )
}


// qrcode only
export function Header2({ pageNumber, totalPages, document, data }) {

    if (!document) return false

    const {
        documentName,
    } = document;


    // console.log('data', data)

    const RenderSection2 = () => {
        return (
            <View
                style={{
                    width: '100%'
                }}
            >
                <View
                    style={{
                        borderTopWidth: 1,
                        borderTopStyle: 'solid',
                        borderTopColor: '#000',

                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#000',

                        borderLeftWidth: 1,
                        borderLeftStyle: 'solid',
                        borderLeftColor: '#000',

                        borderRightWidth: 1,
                        borderRightStyle: 'solid',
                        borderRightColor: '#000',

                        marginBottom: 5

                    }}
                >
                    <Text
                        style={innerStyles.documentName}
                    >
                        {documentName.toUpperCase()}
                    </Text>
                </View>
                <Text
                    style={innerStyles.documentName}
                >
                    {data?.location_name}
                </Text>
            </View>
        )
    }

    return (
        <View style={{
            width: '100%',
            // backgroundColor: 'red'
        }}>
            <View
                style={{
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                    // alignItems: 'flex-start',
                }}
            >
                <View
                    style={{
                        // width: '80%',
                        // flexWrap: 'wrap'
                    }}>
                    <RenderSection2 />
                </View>

                <View
                    style={{
                        textAlign: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Image
                        src={data?.qrCodeData}
                        style={{
                            width: '80',
                            height: '80'
                        }}
                    />
                </View>

                <View
                    style={{
                        textAlign: 'center',
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        // alignItems: 'center',
                    }}
                >
                    <Text style={[styles.h8, {}]}>
                        {data?.number_alternative}
                    </Text>
                    <Text style={styles.h9}>
                        {pageNumber} / {totalPages} {data?.uom_lbl} ({data?.packing_type[0].toUpperCase()})
                    </Text>
                </View>
            </View>
        </View>
    )
}
